'use client';
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
export const StyledNavDrawer = styled(Drawer)(({ theme }) => `
    --drawer-box-max-width: none;

    ${theme.breakpoints.up('xs')} {
        --drawer-box-max-width: 18.75rem;
    }

    .MuiPaper-root {
        box-shadow: none;
        width: 100%;
        max-width: var(--drawer-box-max-width);
    }
`);
